<div *vsLet="allCoverages$ | async as coverages" class="flex flex-col gap-4 mx-6 my-4">
  <div class="flex justify-between gap-2 mt-1">
    <div class="flex flex-wrap gap-2">
      <vs-badge
        class="w-fit rounded-[0.3rem]"
        [class.bg-gray-100]="selectedGroup !== null"
        (click)="selectedGroup = null"
      >
        All
      </vs-badge>

      <vs-badge
        *ngFor="let group of coverages | pluck: 'coverage.group' | unique"
        class="w-fit rounded-[0.3rem]"
        [class.bg-gray-100]="selectedGroup !== group"
        (click)="selectedGroup = group"
      >
        {{ group }}
      </vs-badge>
    </div>

    <div *ngIf="hasDisabledCoverages$ | async" class="flex gap-2 items-center">
      <input
        vsInput
        id="checkbox"
        type="checkbox"
        [checked]="showDisabledCoverages$ | async"
        (click)="showDisabledCoverages$.next(!showDisabledCoverages$.value)"
      />

      <label for="checkbox" class="text-xs text-gray-500 dark:text-gray-300 whitespace-nowrap cursor-pointer">
        Show excluded coverages
      </label>
    </div>
  </div>

  <div
    *vsLet="evaluatedLiabilityGroups$ | async as liabilityGroups"
    class="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-3 w-full min-w-0"
  >
    <ws-coverage-card
      *ngFor="let coverage of pagedCoverages$ | async"
      class="block min-w-0"
      [warranty]="warranty || null"
      [warrantyCoverage]="coverage"
      [isCustomerPortal]="isCustomerPortal"
      [evaluatedLiabilityGroups]="liabilityGroups ?? []"
    ></ws-coverage-card>
  </div>

  <ng-container *vsLet="totalPages$ | async as totalPages">
    <ng-container *vsLet="pageIndex$ | async as pageIndex">
      <div *ngIf="(totalPages || 0) > 1" class="flex flex-col gap-1">
        <div class="flex justify-between items-center px-1">
          <button
            vs-icon-button
            theme="primary"
            appearance="clear"
            class="min-w-[40px] !rounded-full !bg-primary-50"
            [disabled]="(pageIndex || 0) === 0"
            (click)="setPage((pageIndex || 0) - 1)"
          >
            <vs-icon name="chevron-left"></vs-icon>
          </button>

          <div class="flex gap-1 self-center">
            <vs-icon
              *ngFor="let page of pageArray(totalPages); index as idx"
              size="12"
              type="solid"
              name="circle"
              class="cursor-pointer"
              [class.text-primary-500]="(pageIndex || 0) === idx"
              [class.text-primary-200]="(pageIndex || 0) !== idx"
              (click)="setPage(idx)"
            ></vs-icon>
          </div>

          <button
            vs-icon-button
            theme="primary"
            appearance="clear"
            class="min-w-[40px] !rounded-full !bg-primary-50"
            [disabled]="(pageIndex || 0) === (totalPages || 1) - 1"
            (click)="setPage((pageIndex || 0) + 1)"
          >
            <vs-icon name="chevron-right"></vs-icon>
          </button>
        </div>

        <p class="text-xs font-medium text-gray-500 dark:text-gray-400 text-center tracking-wide">
          Page {{ (pageIndex || 0) + 1 }} of {{ totalPages }}
        </p>
      </div>
    </ng-container>
  </ng-container>
</div>
